export default __webpack_public_path__ + "images/pig_f044a9.svg";